// import { X } from "lucide-react";
// import { Logo } from "../footer";
import { PressCards } from "../ui/press-cards";
import { SparklesCore } from "../ui/sparkles";



export const projects = [
    {
        title: "NUQI Digital Wealth attains DFSA license",
        description:
            "Nuqi is gearing up to launch its revolutionary Wealth Advisory mobile app",
        date: "January 23, 2024",
        press: "Gulf News",
        link: "https://gulfnews.com/business/corporate-news/nuqi-digital-wealth-attains-dfsa-license-1.1705932392422",
        image: "gulf.png",
    },
    {
        title: "Discover NUQI WEALTH",
        description:
            "A team of top-tier financial experts and elite technology talent come together to shape a personalised investment journey",
        date: "January 25, 2024",
        press: "DIFC",
        link: "https://www.linkedin.com/posts/difc_nuqiwealth-wechosedifc-activity-7160164331937017857-U_1H/?utm_source=share&utm_medium=member_desktop",
        image: "difc.png",
    },
    {
        title: "Nuqi Digital Wealth secures DFSA licence",
        description:
            "The DFSA licence follows the Securities and Exchange Board licence, giving Nuqi Digital Wealth UAE the green light to introduce its wealth management advisory services in India",
        date: "February 02, 2024",
        press: "Zawya",
        link: "https://www.zawya.com/en/business/fintech/nuqi-digital-wealth-secures-dfsa-licence-spinmed8",
        image: "zawya.png",
    },
    {
        title: "Empowering Gen Z",
        description:
            "Nuqi Digital Wealth’s Approach to Sustainable Investing for the Younger Generation",
        date: "January 22, 2024",
        press: "Daily Guardian",
        link: "https://dailyguardian.ae/empowering-gen-z-nuqi-digital-wealths-approach-to-sustainable-investing-for-the-younger-generation/",
        image: "daily.png",
    },
    {
        title: "Nuqi Digital Wealth granted DFSA licence",
        description:
            "Bolstering its position as a leading ethical financial advisory firm in the UAE",
        date: "January 25, 2024",
        press: "Khaleej Times",
        link: "https://www.khaleejtimes.com/kt-network/nuqi-digital-wealth-granted-dfsa-licence",
        image: "khallej.png",
    },
    {
        title: "NUQI Group secures strategic investment from Landmark Group’s Raza Beig to drive expansion",
        description:
            "With fresh investment, NUQI Group strengthens its position in the financial services sector",
        date: "March 14, 2025",
        press: "Khaleej Times",
        link: "https://www.khaleejtimes.com/kt-network/nuqi-group-secures-strategic-investment-from-landmark-groups-raza-beig-to-drive-expansion",
        image: "khallej.png",
    },
    {
        title: "NUQI Group secures strategic investment from Landmark Group Raza Beig to drive expansion",
        description:
            "With Fresh Investment, NUQI Group Strengthens Its Position in the Financial Services Sector",
        date: "March 17, 2025",
        press: "UAE Times",
        link: "https://uae-times.org/nuqi-group-secures-strategic-investment-from-landmark-group-director-raza-beig-to-drive-expansion/?fbclid=PAY2xjawJGELZleHRuA2FlbQIxMQABpryKvbzBpU6GxrLXrzk11Qm8Wo73b7jlFUkBxoaU0GSus62t27GsiM7T9Q_aem_jDBlQ7c6_svBrrUDrixIlA",
        image: "UAEtimes.png",
    },
    {
        title: "NUQI Gold: A DMCC-Registered Platform Transforming Eid 2025 Gifting with 24K Physical Gold",
        description:
            "Eid remains a cherished occasion in the UAE and around the world",
        date: "March 25, 2025",
        press: "Dubai Global News",
        link: "https://www.dubaiglobalnews.com/2025/03/25/317700/",
        image: "DubaiGlobalNews.png",
    },
    {
        title: "NUQI Gold: A DMCC-Registered Platform Transforming Eid 2025 Gifting with 24K Physical Gold",
        description:
            "Eid remains a cherished occasion in the UAE and around the world",
        date: "March 25, 2025",
        press: "UAE Digital News",
        link: "https://www.uaedigitalnews.com/en/2025/03/25/nuqi-gold-a-dmcc-registered-platform-transforming-eid-2025-gifting-with-24k-physical-gold/#google_vignette",
        image: "UAEDigitalNews.png",
    },
];

const Press = () => {
    return (
        <section className="py-10 sm:py-16 lg:py-20">
            <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
                <div className="h-[10rem] w-full -mt-16 flex flex-col items-center justify-center overflow-hidden rounded-md">
                    <h2 className="text-3xl -mt-16 font-poppins pb-5 font-medium leading-tight tracking-wide text-[#57c0af] hover:text-[#57c0af] sm:text-3xl lg:text-5xl">
                        NEWS
                    </h2>
                    <div className="w-[40rem] h-10 relative">
                        {/* Gradients */}
                        <div className="absolute inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
                        <div className="absolute inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
                        <div className="absolute inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
                        <div className="absolute inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />

                        {/* Core component */}
                        <SparklesCore
                            background="transparent"
                            minSize={0.4}
                            maxSize={1}
                            particleDensity={1200}
                            className="w-full h-full"
                            particleColor="#030F26"
                        />
                        {/* Radial Gradient to prevent sharp edges */}
                        <div className="absolute inset-0 w-full h-full  [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]"></div>
                    </div>
                </div>

                <div className="max-w-3xl mx-auto text-center">

                    <p className="max-w-2xl mx-auto font-poppins  text-base leading-relaxed text-white -mt-14">
                        Explore the latest insights and news coverage of Nuqi
                        Wealth through our press section. Stay informed with
                        articles and press releases that highlight Nuqi Wealth's
                        financial expertise and innovative solutions.
                    </p>
                </div>
            </div>

            <div className="flex justify-center items-center font-poppins  px-2">
                <PressCards items={projects} />
            </div>

            {/* {<div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl pt-10 pb-6">
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-2xl font-bold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#dbc7a6] via-[#3d4957] to-[#282e3a] sm:text-3xl lg:text-4xl">
                        Nuqi Collaborations
                    </h2>
                </div>
            </div>} */}
            {/* <div className="grid md:grid-cols-2 gap-4 md:gap-8 max-w-2xl mx-auto container">
                <div className="relative p-6 flex items-center justify-between mt-6 bg-gradient-to-br from-[#3d4957] to-[#282e3a] text-white shadow-md bg-clip-border rounded-xl max-w-xl text-center">
                    <Logo className="size-16" />
                    <X className="size-8" />
                    <img src="/ifa.png" className="max-w-[10rem]" />
                </div>
                <div className="relative p-6 flex items-center justify-between mt-6 bg-gradient-to-br from-[#3d4957] to-[#282e3a] text-white shadow-md bg-clip-border rounded-xl max-w-xl text-center">
                    <Logo className="size-16" />
                    <X className="size-8" />
                    <img
                        src="/gefi.png"
                        className="max-w-[10rem] object-contain"
                    />
                </div>
            </div> */}
        </section>
    );
};

export default Press;







// import { X } from "lucide-react";
// import { Logo } from "../footer";
// import { PressCards } from "../ui/press-cards";

// export const projects = [
//     {
//         title: "NUQI Digital Wealth attains DFSA license",
//         description:
//             "Nuqi is gearing up to launch its revolutionary Wealth Advisory mobile app",
//         date: "January 23, 2024",
//         press: "Gulf News",
//         link: "https://gulfnews.com/business/corporate-news/nuqi-digital-wealth-attains-dfsa-license-1.1705932392422",
//         image: "gulf.png",
//     },
//     {
//         title: "Nuqi Digital Wealth granted DFSA licence",
//         description:
//             "Bolstering its position as a leading ethical financial advisory firm in the UAE",
//         date: "January 25, 2024",
//         press: "Khaleej Times",
//         link: "https://www.khaleejtimes.com/kt-network/nuqi-digital-wealth-granted-dfsa-licence",
//         image: "khallej.png",
//     },
//     {
//         title: "Empowering Gen Z",
//         description:
//             "Nuqi Digital Wealth’s Approach to Sustainable Investing for the Younger Generation",
//         date: "January 22, 2024",
//         press: "Daily Guardian",
//         link: "https://dailyguardian.ae/empowering-gen-z-nuqi-digital-wealths-approach-to-sustainable-investing-for-the-younger-generation/",
//         image: "daily.png",
//     },
//     {
//         title: "Nuqi Digital Wealth secures DFSA licence",
//         description:
//             "The DFSA licence follows the Securities and Exchange Board licence, giving Nuqi Digital Wealth UAE the green light to introduce its wealth management advisory services in India",
//         date: "February 02, 2024",
//         press: "Zawya",
//         link: "https://www.zawya.com/en/business/fintech/nuqi-digital-wealth-secures-dfsa-licence-spinmed8",
//         image: "zawya.png",
//     },
//     {
//         title: "Discover NUQI WEALTH",
//         description:
//             "A team of top-tier financial experts and elite technology talent come together to shape a personalised investment journey",
//         date: "January 25, 2024",
//         press: "DIFC",
//         link: "https://www.linkedin.com/posts/difc_nuqiwealth-wechosedifc-activity-7160164331937017857-U_1H/?utm_source=share&utm_medium=member_desktop",
//         image: "difc.png",
//     },
// ];

// const Press = () => {
//     return (
//         <section className="py-10 sm:py-16 lg:py-20">
//             <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
//                 <div className="max-w-3xl mx-auto text-center">
//                     <h2 className="text-3xl font-bold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#dbc7a6] via-[#3d4957] to-[#282e3a] sm:text-4xl lg:text-5xl">
//                         Press | Newsroom
//                     </h2>
//                     <p className="max-w-2xl mx-auto mt-4 text-base leading-relaxed text-secondary">
//                         Explore the latest insights and news coverage of Nuqi
//                         Wealth through our press section. Stay informed with
//                         articles and press releases that highlight Nuqi Wealth's
//                         financial expertise and innovative solutions.
//                     </p>
//                 </div>
//             </div>

//             <div className="flex justify-center items-center px-2">
//                 <PressCards items={projects} />
//             </div>

//             <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl pt-10 pb-6">
//                 <div className="max-w-3xl mx-auto text-center">
//                     <h2 className="text-2xl font-bold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#dbc7a6] via-[#3d4957] to-[#282e3a] sm:text-3xl lg:text-4xl">
//                         Nuqi Collaborations
//                     </h2>
//                 </div>
//             </div>
//             <div className="grid md:grid-cols-2 gap-4 md:gap-8 max-w-2xl mx-auto container">
//                 <div className="relative p-6 flex items-center justify-between mt-6 bg-gradient-to-br from-[#3d4957] to-[#282e3a] text-white shadow-md bg-clip-border rounded-xl max-w-xl text-center">
//                     <Logo className="size-16" />
//                     <X className="size-8" />
//                     <img src="/ifa.png" className="max-w-[10rem]" />
//                 </div>
//                 <div className="relative p-6 flex items-center justify-between mt-6 bg-gradient-to-br from-[#3d4957] to-[#282e3a] text-white shadow-md bg-clip-border rounded-xl max-w-xl text-center">
//                     <Logo className="size-16" />
//                     <X className="size-8" />
//                     <img
//                         src="/gefi.png"
//                         className="max-w-[10rem] object-contain"
//                     />
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Press;